"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valle-cannobina": {
    "5ce51140": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "airetta": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a29a622": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "c9355b14": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "cursolo": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb72405a": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "cbe7f869": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "orasso": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;